export interface CalendarDataState {
    newCalendarData: NEWCalendarData
}

const state:CalendarDataState = {
        newCalendarData: {
            calendarData: [],
            nightexpressData: [],
            holidaysData: [],
            bridgeData: [],
            autumnVacationData: [],
            easterVacationData: [],
            pfingstenVacationData: [],
            summerVacationData: [],
            winterVacationData: [],
            springVacationData: [],
        },
    } ;

const mutations = {
    PUSH_CALENDARDATA(state: CalendarDataState, calendarData: NEWDay[]) {
        state.newCalendarData.calendarData.push(...calendarData);
        state.newCalendarData.nightexpressData.push(...calendarData.filter((day: NEWDay) => day.nightexpress === 1));
        state.newCalendarData.holidaysData.push(...calendarData.filter((day: NEWDay) => day.Name !== ""));
        state.newCalendarData.bridgeData.push(...calendarData.filter((day: NEWDay) => day.bridgeday === 1));
        state.newCalendarData.autumnVacationData.push(...calendarData.filter((day: NEWDay) => day.holiday === 1 && day.holidayname === "Herbstferien"));
        state.newCalendarData.easterVacationData.push(...calendarData.filter((day: NEWDay) => day.holiday === 1 && day.holidayname === "Osterferien"));
        state.newCalendarData.pfingstenVacationData.push(...calendarData.filter((day: NEWDay) => day.holiday === 1 && day.holidayname === "Pfingstferien"));
        state.newCalendarData.summerVacationData.push(...calendarData.filter((day: NEWDay) => day.holiday === 1 && day.holidayname === "Sommerferien"));
        state.newCalendarData.winterVacationData.push(...calendarData.filter((day: NEWDay) => day.holiday === 1 && day.holidayname === "Weihnachtsferien"));
    }
};

export default {
    state,
    mutations
};